import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { newsListAction } from "redux/actions/NewsActions/newsListActions";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { Pagination } from "antd";
import { useTranslation } from "react-i18next";
import NewsCard from "./NewsCard";

const News = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(newsListAction(currentPage));
  }, [dispatch, currentPage]);

  const { newsList, newsListLoading } = useSelector(
    (state: RootState) => state.newsListReducer
  );

  const maxPageNumber = Math.ceil(newsList?.pagination?.total_records / 8);

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("News")} />

        {/* news cards *********************************************/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px] w-full min-h-[300px] px-[20px] lg:px-0"
        >
          <div className="mainContainer w-full h-full">
            <Spin spinning={newsListLoading}>
              <div className="w-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-4 gap-[20px] xl:gap-[30px]">
                {newsList?.data?.map((singleNews: any, i: number) => {
                  return <NewsCard data={singleNews} />;
                })}
              </div>
            </Spin>
          </div>

          {/* pagination  *********************************************/}
          <div className="my-[100px] flex items-center justify-center">
            <div className="">
              <Pagination
                onChange={(page: any) => {
                  setCurrentPage(page);
                }}
                current={currentPage}
                total={maxPageNumber * 10}
                nextIcon={false}
                prevIcon={false}
              />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default News;
